import { FilterChoice } from '../../common/components/SearchHeader/types/FilterChoice';

/** Takes two sets of filters: the current filters, and those from a preset.
 * Returns a new filter-set combining important parts of the current filters (location and online),
 * taking everything else from the preset.
 */
export const composeFilters = (
  filters: FilterChoice,
  presetFilters: FilterChoice,
): FilterChoice => ({
  location: filters.location,
  ...presetFilters,
});
